/**
 * B3 (founder 14-oct-2026) — advertencia «Conflicto de horario» antes de encimar una cita
 * sobre otra, un bloqueo, un descanso o fuera de horario. Solo el barbero (manual); online nunca.
 * Founder 22-oct-2026 («forzar») — muestra la lista EXACTA de reglas que rompe (desde el 409) y
 * «Agendar / Mover de todas formas». Forzar no cambia la disponibilidad online ni aplica recargo premium.
 */
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { tr } from '@/contexts/LanguageContext';

export const isScheduleConflict = (err) => err?.status === 409 && err?.payload?.detail?.code === 'schedule_conflict';
export const conflictRules = (err) => (Array.isArray(err?.payload?.detail?.rules) ? err.payload.detail.rules : []);

const KIND = { break: "descanso", block: "bloqueo", time_off: "tiempo libre" };
const fill = (tpl, p) => tpl.replace(/\{(\w+)\}/g, (_, k) => (p[k] ?? ''));
// Texto traducible de cada regla (el backend manda `params`; `message` en español queda de respaldo).
export const ruleText = (r) => {
  const p = r.params;
  if (!p) return r.message;
  switch (r.rule) {
    case 'overlap': return p.full ? fill(tr("Se solapa por completo con la cita de {who} de {time}"), p) : fill(tr("Se solapa {minutes} min con la cita de {who} de {time}"), p);
    case 'before_open': return fill(tr("Es antes de tu apertura de {time}"), p);
    case 'after_close': return fill(tr("Es después de tu cierre de {time}"), p);
    case 'closed_day': return tr("Ese día está cerrado");
    case 'break': case 'block': case 'time_off':
      return fill(tr("Está en tu {kind}{name} de {start} a {end}"), { ...p, kind: tr(KIND[r.rule]), name: p.name ? ` «${p.name}»` : '' });
    default: return r.message;
  }
};

export const ScheduleConflictDialog = ({ open, onContinue, onBack, busy = false, rules = [], verb = 'agendar' }) => (
  <AlertDialog open={open} onOpenChange={(o) => { if (!o) onBack(); }}>
    <AlertDialogContent className="bg-card border-border" data-testid="schedule-conflict-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display">{tr("Conflicto de horario")}</AlertDialogTitle>
        <AlertDialogDescription asChild>
          <div data-testid="schedule-conflict-text" className="text-sm text-muted-foreground space-y-2">
            {rules.length ? (
              <ul className="list-disc pl-5 space-y-1 text-left" data-testid="schedule-conflict-rules">
                {rules.map((r, i) => <li key={i} className="text-foreground" data-testid={`schedule-conflict-rule-${r.rule || i}`}>{ruleText(r)}</li>)}
              </ul>
            ) : (
              <p>{tr("Esta cita coincide con otras ya existentes o con un horario en el que estás cerrado. Si continúas, puede haber conflictos con tus citas, bloqueos o horario.")}</p>
            )}
            <p className="text-xs text-left">{verb === 'mover'
              ? tr("Si la mueves de todas formas, solo ocupa ese tiempo: tu disponibilidad para clientes no cambia y no se aplica recargo de horario premium.")
              : tr("Si la pones de todas formas, solo ocupa ese tiempo: tu disponibilidad para clientes no cambia y no se aplica recargo de horario premium.")}</p>
          </div>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="rounded-full" disabled={busy} data-testid="schedule-conflict-back">{tr("Atrás")}</AlertDialogCancel>
        <AlertDialogAction onClick={(e) => { e.preventDefault(); onContinue(); }} disabled={busy} className="rounded-full" data-testid="schedule-conflict-continue">
          {verb === 'mover' ? tr("Mover de todas formas") : tr("Agendar de todas formas")}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default ScheduleConflictDialog;
